module.exports = "footer{\n  background-color: #E5E5E5;\n  font-family: QuicksandRegular;\n  padding-top: 20px;\n}\na .footerlinks{\n  color: white;\n}\n"